var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelhiveryLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 18,
    viewBox: "0 0 112 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 0.00634766H107.915V7.05489L106.262 9.09379L104.602 7.05489V0.00634766H100.517V8.55006L104.219 13.0873V17.9481H108.298V13.0873L112 8.55006V0.00634766Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0312 0.103516H58.1097V17.9869H54.0312V0.103516Z",
    fill: "#1A181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8964 17.877H88.8115V2.07117L90.854 0H98.4493V4.14234H92.8964V17.877Z",
    fill: "#1A181E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7219 13.8186V11.1132H84.1966V6.97724H79.7219V4.14877L81.3048 4.14234L86.041 4.16194L86.054 0.0194306L81.3112 0L77.6666 0.0194306L75.6367 2.0906V15.8834L77.6795 17.9546H81.292L86.041 17.974L86.054 13.8382L81.2987 13.8186H79.7219Z",
    fill: "#1A181E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.437 11.3656L66.7776 13.3981L65.118 11.3656V0.097168H61.0396V12.8479L65.1883 17.9481H68.3667L72.5154 12.8479V0.097168H68.437V11.3656Z",
    fill: "#1A181E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3871 13.8644H4.09782V4.15566H8.3871V13.8644ZM6.81049 0.0585938H0V18.0001H10.4231L12.4529 15.929V2.12977L10.4104 0.0585938H6.81049Z",
    fill: "#1A181E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7568 4.14234L25.493 4.16194L25.5122 0.0194306L20.7633 0L17.1187 0.0194306L15.0889 2.0906V15.8834L17.1315 17.9546H20.7442L25.493 17.974L25.5122 13.8382L20.7568 13.8186H19.174V11.1132H23.6483V6.97724H19.174V4.14877L20.7568 4.14234Z",
    fill: "#1A181E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8951 0.0585938H27.8164V15.9095L29.8589 17.9743H37.4482V13.8385H31.8951V0.0585938Z",
    fill: "#1A181E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1885 0.097455V6.97754H43.5249V0.0585938H39.4463V17.9873H43.5249V11.1135H47.1885V17.9873H51.2737V0.097455H47.1885Z",
    fill: "#1A181E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0253906 13.8643H4.09121V17.9872H0.0253906V13.8643Z",
    fill: "#1A181E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.928 0.00634766H111.994V4.12943H107.928V0.00634766Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelhiveryLogo);
export default __webpack_public_path__ + "static/media/delhivery-logo.6c288cf3fbd49110c686069f3328d0b1.svg";
export { ForwardRef as ReactComponent };